import React, { useState, useEffect, useContext } from "react";

// API
import { getRaffleProducts, getHeroRaffles } from "../api/raffle";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

// Custom Components
import RaffleProduct from "../components/RaffleProduct/RaffleProduct";

// Contexts
import AlertContext from "../context/AlertContext";

// Custom CSS
import "../assets/scss/pages/bids.scss";

export default function Bids() {
  const [products, setProducts] = useState(null);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [pageHeroBackground, setPageHeroBackground] = useState({});

  const alert = useContext(AlertContext);

  const [isSubmittingBid, setIsSubmittingBid] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await getRaffleProducts();
      if (response.error) {
        console.log("Error,", response.error);
        alert.error(response.error);
      } else {
        setProducts(response.docs);
      }
      setLoadingProducts(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getHeroRaffles();
      if (response !== null && !response.error) {
        setPageHeroBackground(response);
      } else {
        setPageHeroBackground({});
        alert.error(response.message);
      }
    })();
  }, []);

  if (loadingProducts) {
    return (
      <div className="bids__wrapper">
        <Container>
          <p className="py-4">Cargando información...</p>
        </Container>
      </div>
    );
  }

  return (
    <div className="bids__wrapper">
      <div
        className="jumbotron"
        style={{
          backgroundImage: `url(${pageHeroBackground?.imagen?.url})`,
        }}
      ></div>
      <div className="bids__header">
        <Container>
          <h3>Subastas</h3>
          <p>
            Te invitamos a que conozcas nuestra eficiente forma de venta express
            en la cual encontrarás los mejores precios de toda la página los
            cuales consistirán en que ciertos relojes serán subastados
            diariamente de manera aleatoria en la página, los cuales podrán ser
            de una a múltiples subastas en el mismo día, estas se regirán por la
            regla general de una puja inicial, seguido de pujas mínimas fijas o
            máximas libres dando al ganador la puja más alta a la hora del
            cierre estipulado en cada subasta publicada.
          </p>
        </Container>
      </div>
      <div className="bids__container">
        {isSubmittingBid && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "30px 40px",
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#333",
                }}
              >
                Procesando puja...
              </span>
            </div>
          </div>
        )}

        <style>
          {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
        </style>
        <Container>
          <Row>
            {products?.map((product, key) => (
              <RaffleProduct
                key={product.id || key}
                product={product}
                isSubmittingBid={isSubmittingBid}
                setIsSubmittingBid={setIsSubmittingBid}
              />
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
}
